// extracted by mini-css-extract-plugin
export default {"table":"warehouse_table__119m3","cellWrapper":"warehouse_cellWrapper__6gCoM","image":"warehouse_image__nNY0v","productStatus":"warehouse_productStatus__pkFCx"};